export const SET_CANDIDATE = "SET_CANDIDATE";
export type dispathType = typeof SET_CANDIDATE;
